import React, { useState } from "react";
import "../styles/StaffApply.css";

const StaffApply = () => {
  const [formData, setFormData] = useState({
    name: "",
    discord: "",
    serverType: "", // Minecraft Server or Discord Server
    role: "",
    why: "",
    experience: "",
  });
  const [successMsg, setSuccessMsg] = useState("");

  const rolesByServer = {
    "Minecraft Server": [
      "Admin",
      "Moderator",
      "Junior Moderator",
      "Chat Moderator",
      "Helper",
    ],
    "Discord Server": [
      "Admin",
      "Moderator",
      "Support",
      "Event Staff",
      "Helper",
    ],
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    // If serverType changes, reset role
    if (id === "serverType") {
      setFormData((prev) => ({ ...prev, [id]: value, role: "" }));
    } else {
      setFormData((prev) => ({ ...prev, [id]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const webhookURL =
      "https://discord.com/api/webhooks/1375128178640552057/mfdk9DRHZo-uf9A3NExc3Gik3Ux6hO4zVTnhgGHLEI4vPlc1KSMmrz2eCE4rajRgsZIH";

    const payload = {
      username: "RixxyMC Bot",
      embeds: [
        {
          title: "📩 New Staff Application",
          color: 5814783,
          fields: [
            { name: "👤 Minecraft Username", value: formData.name },
            { name: "💬 Discord Tag", value: formData.discord },
            { name: "🌐 Applying For", value: formData.serverType },
            { name: "📌 Role Applied", value: formData.role },
            { name: "📝 Why They Want to Join", value: formData.why },
            { name: "🧠 Experience", value: formData.experience || "None" },
          ],
          footer: {
            text: "RixxyMC Application System",
          },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccessMsg("✅ Application sent successfully!");
        setFormData({
          name: "",
          discord: "",
          serverType: "",
          role: "",
          why: "",
          experience: "",
        });
      } else {
        setSuccessMsg("❌ Failed to send. Check webhook URL.");
      }
    } catch (err) {
      console.error(err);
      setSuccessMsg("❌ Error sending application.");
    }
  };

  return (
    <div className="container">
      <h2>RixxyMC Staff Application</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Minecraft Username:</label>
        <input
          type="text"
          id="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Minecraft Username"
          required
        />

        <label htmlFor="discord">Discord Tag (e.g. user#1234):</label>
        <input
          type="text"
          id="discord"
          value={formData.discord}
          onChange={handleChange}
          placeholder="Your Discord Tag"
          required
        />

        <label htmlFor="serverType">Apply for:</label>
        <select
          id="serverType"
          value={formData.serverType}
          onChange={handleChange}
          required
        >
          <option value="" disabled>
            -- Select Server Type --
          </option>
          <option value="Minecraft Server">RixxyMC Minecraft Server</option>
          <option value="Discord Server">RixxyMC Discord Server</option>
        </select>

        <label htmlFor="role">Role Applied For:</label>
        <select
          id="role"
          value={formData.role}
          onChange={handleChange}
          required
          disabled={!formData.serverType}
        >
          <option value="" disabled>
            {formData.serverType
              ? "-- Select Role --"
              : "Select server type first"}
          </option>
          {formData.serverType &&
            rolesByServer[formData.serverType].map((role) => (
              <option
                key={role}
                value={role}
                disabled={role === "Admin"} // Disable Admin role always
                title={role === "Admin" ? "This position is currently full" : ""}
              >
                {role} {role === "Admin" ? "(Full)" : ""}
              </option>
            ))}
        </select>

        <label htmlFor="why">Why do you want to be staff?</label>
        <textarea
          id="why"
          rows="4"
          value={formData.why}
          onChange={handleChange}
          placeholder="Tell us why you want to join the staff team"
          required
        ></textarea>

        <label htmlFor="experience">Do you have any prior experience?</label>
        <textarea
          id="experience"
          rows="3"
          value={formData.experience}
          onChange={handleChange}
          placeholder="List any relevant experience (optional)"
        ></textarea>

        <button type="submit">Submit Application</button>
        {successMsg && <div className="success">{successMsg}</div>}
      </form>
    </div>
  );
};

export default StaffApply;
